/*
 * @Author: Json Chen
 * @Date: 2021-06-28 10:12:52
 * @LastEditTime: 2021-08-10 10:09:53
 * @LastEditors: Teemo Ding
 * @Description: 可拖拽 输入框 组件,带有校验和删除
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeModalOptions.tsx
 */

import React from 'react';
import { Form, Input, Button } from 'antd';
import { DragNDrop } from '@/src/components';
import {
  // 移动手柄
  MenuOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { randomNumber } from '@/src/tools/helper';
import styles from '../style.module.less';

const AttributeOptions = ({
  value: list = [],
  onChange,
  inputKey = '',
  // 只有 Unit of Measurement 才有
  defaultOptions,
  // 设置 弹窗的 Confirm 按钮置灰不可点
  setConfirmDisable,
}: any) => {
  const handleOnDragChange = (oldIndex, newIndex) => {
    const item = list.splice(oldIndex, 1)[0];
    list.splice(newIndex, 0, item);
    onChange(list);
  };
  const handleOnDel = (i) => {
    onChange(list.filter((_, index) => index !== i));
  };
  return (
    <DragNDrop
      droppableId={randomNumber()}
      list={list}
      childGenerator={(item, provided, index) => {
        return (
          <div className={styles.dragItemWrap}>
            <i
              {...provided.dragHandleProps}
              className={`${styles.icon} ${styles.dragHandle}`}>
              <MenuOutlined />
            </i>
            <div className={styles.input}>
              <Form.Item
                name={['options', index, inputKey]}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    required: true,
                    message: 'Brand Name Cannot Empty',
                  },
                  {
                    validator: (_, value) => {
                      let hasSame = false;
                      if (defaultOptions && defaultOptions.length) {
                        hasSame = defaultOptions.some(
                          (item) => item[inputKey] === value,
                        );
                      }

                      if (!hasSame) {
                        hasSame = list
                          .filter((p, i) => i !== index)
                          .some((p, i) => p[inputKey] === value);
                      }
                      // 设置confirm disable
                      setConfirmDisable(hasSame || !value);
                      return hasSame
                        ? Promise.reject(
                            new Error(
                              'The same attribute option already exists',
                            ),
                          )
                        : Promise.resolve();
                    },
                  },
                ]}>
                <Input size='large' />
              </Form.Item>
            </div>
            <i className={`${styles.icon} ${styles.delete}`}>
              <Button
                onClick={() => handleOnDel(index)}
                type='text'
                disabled={!item.deletable}>
                <DeleteOutlined />
              </Button>
            </i>
          </div>
        );
      }}
      onChange={handleOnDragChange}
    />
  );
};

export default AttributeOptions;
